/* Verdurra — theme.js */
(function () {
  'use strict';

  /* ── Sticky header ──────────────────────────────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile nav ─────────────────────────────────────────── */
  const menuBtn    = document.getElementById('menu-open');
  const mobileNav  = document.getElementById('mobile-nav');
  const menuClose  = document.getElementById('menu-close');
  const menuOverlay = document.getElementById('menu-overlay');

  function openMenu() {
    mobileNav && mobileNav.classList.add('is-open');
    mobileNav && mobileNav.setAttribute('aria-hidden', 'false');
    menuOverlay && menuOverlay.classList.add('is-visible');
    menuBtn && menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    menuClose && menuClose.focus();
  }

  function closeMenu() {
    mobileNav && mobileNav.classList.remove('is-open');
    mobileNav && mobileNav.setAttribute('aria-hidden', 'true');
    menuOverlay && menuOverlay.classList.remove('is-visible');
    menuBtn && menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  menuBtn     && menuBtn.addEventListener('click', openMenu);
  menuClose   && menuClose.addEventListener('click', closeMenu);
  menuOverlay && menuOverlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
      closeSearch();
    }
  });

  /* ── Search overlay ──────────────────────────────────────── */
  const searchBtns    = document.querySelectorAll('[data-search-open]');
  const searchClose   = document.getElementById('search-close');
  const searchBackdrop = document.getElementById('search-backdrop');
  const searchOverlay = document.getElementById('search-overlay');
  const searchInput   = document.getElementById('search-overlay-input');
  const searchClear   = document.getElementById('search-clear');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchBackdrop && searchBackdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput && searchInput.focus(), 50);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchBackdrop && searchBackdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  searchBtns.forEach(btn => btn.addEventListener('click', openSearch));
  searchClose   && searchClose.addEventListener('click', closeSearch);
  searchBackdrop && searchBackdrop.addEventListener('click', closeSearch);

  if (searchInput && searchClear) {
    searchInput.addEventListener('input', function () {
      searchClear.hidden = !this.value.length;
    });
    searchClear.addEventListener('click', function () {
      searchInput.value = '';
      searchClear.hidden = true;
      searchInput.focus();
      const resultsEl = document.getElementById('search-results');
      if (resultsEl) resultsEl.innerHTML = '';
    });
  }

  /* ── Gallery thumbnails ──────────────────────────────────── */
  function initGallery(container) {
    if (!container) return;
    const mainImg  = container.querySelector('.gallery-main__img');
    const thumbs   = container.querySelectorAll('.gallery-thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const src      = this.dataset.src;
        const alt      = this.dataset.alt || '';
        mainImg.src    = src;
        mainImg.srcset = '';
        mainImg.alt    = alt;
        thumbs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  initGallery(document.querySelector('.product-gallery'));

  /* ── Product tabs ────────────────────────────────────────── */
  const tabList = document.querySelector('.tab-list');
  if (tabList) {
    const tabBtns   = tabList.querySelectorAll('.tab-btn');
    const tabPanels = document.querySelectorAll('.tab-panel');

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const target = this.dataset.tab;
        tabBtns.forEach(b => { b.classList.remove('active'); b.setAttribute('aria-selected', 'false'); });
        tabPanels.forEach(p => p.classList.remove('active'));
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        const panel = document.getElementById('tab-' + target);
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* ── Variant selector ────────────────────────────────────── */
  const variantBtns = document.querySelectorAll('.variant-btn');
  const variantIdInput = document.getElementById('variant-id-input');
  const variantsDataEl = document.getElementById('product-variants-json');
  const allVariants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];

  function getSelectedOptions() {
    const selected = {};
    document.querySelectorAll('.variant-options').forEach(function (group) {
      const activeBtn = group.querySelector('.variant-btn.active');
      if (activeBtn) selected[group.dataset.optionIndex] = activeBtn.dataset.value;
    });
    return selected;
  }

  function updateVariantId() {
    if (!variantIdInput || !allVariants.length) return;
    const selected = getSelectedOptions();
    const match = allVariants.find(function (v) {
      return v.options.every(function (opt, i) {
        return selected[String(i)] === opt;
      });
    });
    if (match) variantIdInput.value = match.id;
  }

  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const group = this.closest('.variant-options');
      if (group) group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      updateVariantId();
    });
  });

  /* ── Quantity selector ───────────────────────────────────── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const input = btn.closest('.qty-selector')?.querySelector('.qty-input');
    if (!input) return;
    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || 99;
    let val   = parseInt(input.value) || 1;
    if (btn.dataset.qty === 'minus') val = Math.max(min, val - 1);
    if (btn.dataset.qty === 'plus')  val = Math.min(max, val + 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Sort dropdown ──────────────────────────────────────── */
  const sortSelect = document.getElementById('collection-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── Filter groups (collapsible) ─────────────────────────── */
  document.addEventListener('click', function (e) {
    const title = e.target.closest('.filter-group__title');
    if (!title) return;
    const group = title.closest('.filter-group');
    group && group.classList.toggle('is-collapsed');
  });

  /* ── Filter drawer (mobile) ──────────────────────────────── */
  const filterDrawerOpen  = document.getElementById('filter-drawer-open');
  const filterDrawer      = document.getElementById('filter-drawer');
  const filterDrawerClose = document.getElementById('filter-drawer-close');
  const filterDrawerOverlay = document.getElementById('filter-drawer-overlay');

  function openFilterDrawer() {
    filterDrawer && filterDrawer.classList.add('is-open');
    filterDrawer && filterDrawer.setAttribute('aria-hidden', 'false');
    filterDrawerOverlay && filterDrawerOverlay.classList.add('is-visible');
    filterDrawerOpen && filterDrawerOpen.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeFilterDrawer() {
    filterDrawer && filterDrawer.classList.remove('is-open');
    filterDrawer && filterDrawer.setAttribute('aria-hidden', 'true');
    filterDrawerOverlay && filterDrawerOverlay.classList.remove('is-visible');
    filterDrawerOpen && filterDrawerOpen.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  filterDrawerOpen    && filterDrawerOpen.addEventListener('click', openFilterDrawer);
  filterDrawerClose   && filterDrawerClose.addEventListener('click', closeFilterDrawer);
  filterDrawerOverlay && filterDrawerOverlay.addEventListener('click', closeFilterDrawer);

  /* ── Toast notifications ─────────────────────────────────── */
  window.Verdurra.showToast = function (message, type) {
    let toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.className   = 'toast' + (type ? ' toast--' + type : '');
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3200);
  };

  /* ── Newsletter form ─────────────────────────────────────── */
  /* Let the native Shopify customer form submit — no JS intercept. */

})();
